import React from "react";
import logo from "../../../assets/kangaroo/KEVS-02.png";
import { Col, Container, Row } from "reactstrap";
import fbIcon from "../../../assets/kangaroo/facebookIcon.png";
import inIcon from "../../../assets/kangaroo/instagramIcon.png";
import tiktokIcon from "../../../assets/kangaroo/tiktokIcon.png";

import { motion } from "framer-motion";
import "../../../Homepage/Component/Homepage.css";
import { Link } from "react-router-dom";
import PrivacyService from "../../../services/Privacy";
import { useQuery } from "@tanstack/react-query";
import FooterService from "../../../services/FooterService";
import { imageBaseApi } from "../../../services/imageBaseApi";

const FooterMenu = ({ menu }) => {



  if (!menu) return null;

  return (
    <div style={{ width: "max-content" }} className="mb-5">
      <h5 className="mb-3 navbar-btn-font text-white text-uppercase font-bold">
        {menu.title}
      </h5>

      <div className="d-flex flex-column gap-2">
        {menu.children
          ?.filter((child) => child.isActive)
          ?.sort((a, b) => a.orderIndex - b.orderIndex)
          ?.map((child) =>
            child.isExternal ? (
              <a
                key={child.id}
                href={child.url}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-item-font text-white"
                style={{ cursor: "pointer", textDecoration: "none" }}
              >
                {child.title}
              </a>
            ) : (
              <Link
                key={child.id}
                to={child.url}
                className="footer-item-font text-white"
                style={{ cursor: "pointer", textDecoration: "none" }}
              >
                {child.title}
              </Link>
            )
          )}
      </div>
    </div>
  );
};

const Footer = ({ footerMenus = [] }) => {
  const fetchData = async () => {
    const response = await PrivacyService.getList()
    return response?.items
  }

  const { isLoading, error, data } = useQuery({
    queryKey: ["privacy"],
    queryFn: fetchData,
  })

  const fetchFooterData = async () => {
    const response = await FooterService.getList()
    return response
  }

  const { data: footerData } = useQuery({
    queryKey: ["footer"],
    queryFn: fetchFooterData,
  })



  return (

    <div
      className="position-relative"
      style={{
        backgroundColor: "#7D178F",
        paddingTop: "72px",
        paddingBottom: "3rem",
      }}
    >
      {/* Triangle Shape - Bottom Left */}


      <Container className="w-100 position-relative">
        {/* HEADER SECTION */}
        <Row className="mb-5 align-items-start">
          {/* LEFT COLUMN - Logo and Buttons */}
          <Col xs={12} md={4} className="mb-5 mb-md-0">
            {/* Logo - Left aligned */}
            <div className="mb-4">
              <img
                src={logo}
                alt="KEVS Logo"
                className="img-fluid"
                style={{ maxHeight: "106px" }}
              />
            </div>

            {/* Buttons - Left aligned */}
            <div className="d-flex flex-column align-items-start gap-3 mt-5">
              <Link to="/contact" className="text-decoration-none">
                <motion.button
                  className="rounded-pill border border-white navbar-btn-font"
                  style={{
                    backgroundColor: "transparent",
                    width: "275px",
                    height: "45px",
                    position: "relative",
                    overflow: "hidden",
                    cursor: "pointer",
                  }}
                  whileHover="hover"
                >
                  <motion.div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "#FF6A17",
                      zIndex: 0,
                    }}
                    initial={{ x: "-100%" }}
                    variants={{ hover: { x: 0 } }}
                    transition={{ duration: 0.5, ease: "easeInOut" }} />

                  <motion.span
                    style={{ position: "relative", zIndex: 1 }}
                    initial={{ color: "#fff" }}
                    variants={{ hover: { color: "#fff" } }}
                  >
                    CONTACT US
                  </motion.span>
                </motion.button>
              </Link>
              <Link to={"/freecounseling"} className="text-decoration-none">
                <motion.button
                  className="rounded-pill navbar-btn-font"
                  style={{
                    width: "275px",
                    height: "45px",
                    border: "0px",
                    position: "relative",
                    background: "#FF6A17",
                    overflow: "hidden",
                    cursor: "pointer",
                  }}
                  whileHover="hover"
                >
                  <motion.div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "linear-gradient(to right, #83168F, #D40B84)",
                      zIndex: 0,
                    }}
                    initial={{ x: "-100%" }}
                    variants={{ hover: { x: 0 } }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                  />
                  <motion.span
                    style={{ position: "relative", zIndex: 1 }}
                    initial={{ color: "#fff" }}
                    variants={{ hover: { color: "#fff" } }}
                  >
                    BOOK FOR CONSULTATION
                  </motion.span>
                </motion.button>
              </Link>
            </div>
          </Col>

          {/* MIDDLE COLUMN - Menu Links */}
          <Col xs={12} md={4} className="mb-5 mb-md-0 ps-5">
            <FooterMenu menu={footerMenus[0]} />
            <FooterMenu menu={footerMenus[1]} />
            <FooterMenu menu={footerMenus[2]} />
          </Col>

          {/* RIGHT COLUMN - Location Details */}
          <Col xs={12} md={4} className="ps-5">
            {/* SYDNEY */}
            {footerData?.filter((item) => item?.isActive === true && item?.isTextOnly === false)?.map((item) => (<div className="mb-5">
              <h5 className="mb-2 navbar-btn-font text-white">{item?.name}</h5>
              <p className="mb-1 footer-item-font text-white">
                {item?.address}
              </p>

              <p className="mb-1 footer-item-font text-white">
                T: {item?.phone}
              </p>
              <p className="mb-3 footer-item-font text-white">
                E: {item?.email}
              </p>
              <div className="d-flex justify-content-start gap-3">
                <a
                  href={item?.facebookImage?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={imageBaseApi + item?.facebookImage?.url}
                    style={{ width: "32px", height: "32px" }}
                    alt="Facebook"
                  />
                </a>

                {/* <a
                  href="https://www.instagram.com/kangaroo_education_foundation/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={inIcon}
                    style={{ width: "32px", height: "32px" }}
                    alt="Instagram"
                  />
                </a> */}

                <a
                  href={item?.tiktokUrl?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={imageBaseApi + item?.tikTokImage?.url}
                    style={{ width: "32px", height: "32px" }}
                    alt="TikTok"
                  />
                </a>
              </div>

            </div>))}

            {/* ADELAIDE */}
            {/* <div className="mb-5">
              <h5 className="mb-2 navbar-btn-font text-white">ADELAIDE</h5>
              <p className="mb-1 footer-item-font text-white">
                Level 2, Suite 220, 147 Pirie Street
              </p>
              <p className="mb-1 footer-item-font text-white">
                Adelaide, 5000, SA  
              </p>
              <p className="mb-1 footer-item-font text-white">
                T: +61 403 603 225
              </p>
              <p className="mb-3 footer-item-font text-white">
                E: adelaide@kangarooedu.com
              </p>

              <div className="d-flex justify-content-start gap-3">
                <a
                  href="https://www.facebook.com/KEFAdelaide"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={fbIcon}
                    style={{ width: "32px", height: "32px" }}
                    alt="Facebook"
                  />
                </a>


                <a
                  href="https://www.tiktok.com/@kangarooeduadelaide"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={tiktokIcon}
                    style={{ width: "32px", height: "32px" }}
                    alt="TikTok"
                  />
                </a>
              </div>

            </div> */}

            {/* TASMANIA */}
            {/* <div className="mb-5">
              <h5 className="mb-2 navbar-btn-font text-white">TASMANIA</h5>
              <p className="mb-1 footer-item-font text-white">
                Level 1, 122B Elizabeth 
              </p>
              <p className="mb-1 footer-item-font text-white">
                St. Hobart TAS 7000
              </p>
              <p className="mb-1 footer-item-font text-white">
                T: +61 452 117 383


              </p>
              <p className="mb-3 footer-item-font text-white">
                E: tasmania@kangarooedu.com
              </p>

              <div className="d-flex justify-content-start gap-3">
                <a
                  href="https://www.tiktok.com/@kangaroo.tasmania"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={fbIcon}
                    style={{ width: "32px", height: "32px" }}
                    alt="Facebook"
                  />
                </a>

            

                <a
                  href="https://www.tiktok.com/@kangarooeduadelaide"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={tiktokIcon}
                    style={{ width: "32px", height: "32px" }}
                    alt="TikTok"
                  />
                </a>
              </div>

            </div> */}
          </Col>
        </Row>

        {/* FOOTER BOTTOM - Left aligned */}
        <Row className="mt-4">
          <Col md={4}></Col>
          <Col md={8} className="">
            <div className="d-flex justify-content-start gap-3 gap-md-4 flex-wrap">
              {data && data?.map((item, index) => (
                <Link to={`/privacy/${item?.slug}`}
                  key={index} // always provide a unique key if possible
                  className="text-white"
                  style={{ fontSize: "14px" }}
                >
                  {item?.heading}
                </Link>
              ))}

              <span className="text-white" style={{ fontSize: "14px" }}>

                {footerData?.filter(item => item?.isTextOnly === true)?.map((item) => item?.name).join(" ")}
              </span>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Footer;